import Image from 'next/image';
import { Box, Typography, Grid2 } from '@mui/material';
import { convertStringToParagraphs } from '@qb/frontend/utils/convertStringToParagraphs';
import { truncateWithEllipsis } from '@qb/frontend/utils/truncateWithEllipsis';
import { PartDisplayDataResponse } from '@/shared/types/controllers/sps/SPSPartControllerTypes';
type PartAboutTheCategoryProps = {
  partCategory: NonNullable<PartDisplayDataResponse['partCategoriesToRoot'][0]>;
  partCategoryDescription: string | undefined;
};
export const PartAboutTheCategory = ({
  partCategory,
  partCategoryDescription
}: PartAboutTheCategoryProps) => {
  if (!partCategory || !partCategoryDescription) {
    return null;
  }
  return <Box sx={{
    mt: 4,
    mb: 7
  }} data-sentry-element="Box" data-sentry-component="PartAboutTheCategory" data-sentry-source-file="PartAboutTheCategory.tsx">
      <Typography variant="h4" sx={{
      mb: 2
    }} data-sentry-element="Typography" data-sentry-source-file="PartAboutTheCategory.tsx">
        About the Product Category
      </Typography>
      <Grid2 container spacing={3} data-sentry-element="Grid2" data-sentry-source-file="PartAboutTheCategory.tsx">
        <Grid2 size={{
        xs: 12,
        md: 10
      }} data-sentry-element="Grid2" data-sentry-source-file="PartAboutTheCategory.tsx">
          <Typography variant="paragraph" sx={{
          whiteSpace: 'pre-line'
        }} data-sentry-element="Typography" data-sentry-source-file="PartAboutTheCategory.tsx">
            {convertStringToParagraphs(truncateWithEllipsis(partCategoryDescription, 400))}
          </Typography>
        </Grid2>
        <Grid2 size={{
        xs: 12,
        md: 2
      }} data-sentry-element="Grid2" data-sentry-source-file="PartAboutTheCategory.tsx">
          {!!partCategory.imageURL && <Image src={partCategory.imageURL} alt={partCategory.name} title={partCategory.name} width={300} height={200} style={{
          objectFit: 'contain',
          maxWidth: '100%',
          height: 'auto'
        }} />}
        </Grid2>
      </Grid2>
    </Box>;
};